import styled, { css } from 'styled-components';
import { palette } from 'styles/colors';

export const ToggleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 32px;
  font-size: 18px;
`;

const translateSwitched = css`
  transform: translateX(24px);
`;

interface ToggleProps {
  switched?: boolean;
  toogleBackgroundColor?: string;
  toogleColor?: string;
}

export const Toggle = styled.div<ToggleProps>`
  position: relative;
  cursor: pointer;
  transition: all .3s ease-in-out;
  border: 1px solid ${palette.fog};
  border-radius: 100px;
  background-color: ${({ toogleBackgroundColor }) => toogleBackgroundColor ?? 'transparent'};
  width: 60px;
  height: 32px;
  margin: 0 16px;

  &:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    left: 5px;
    bottom: 4px;
    background-color: ${({ toogleColor }) => toogleColor ?? palette.snowFlower};
    transition: all .3s ease-in-out;
    border-radius: 50%;

    ${({ switched }) => switched ? translateSwitched : ''}
  }
`;
